import { useState } from "react"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import CustomModal from "../../../../common/AdminCommonComponents/CustomModal/CustomModal"
import DynamicDropdown from "../../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import ColoredText from "../../../../common/AdminCommonComponents/ColoredText/ColoredText"

const Repayment = ({ onClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const actions = [
    { label: 'View Details', action: () => onClick(prev => !prev) }
  ]

  const tableData = [
    { loanID: "Loan-0001", sellerName: "Lorem Ipsum", nextPaymentDue: "05/12/2024", overdueAmount: "$0", totalPaid: "$3,000", status: "Active" },
    { loanID: "Loan-0001", sellerName: "Lorem Ipsum", nextPaymentDue: "05/12/2024", overdueAmount: "$0", totalPaid: "$3,000", status: "Active" },
    { loanID: "Loan-0001", sellerName: "Lorem Ipsum", nextPaymentDue: "05/12/2024", overdueAmount: "$0", totalPaid: "$3,000", status: "Active" },
    { loanID: "Loan-0001", sellerName: "Lorem Ipsum", nextPaymentDue: "05/12/2024", overdueAmount: "$0", totalPaid: "$3,000", status: "Active" },
  ]

  const tableCols = [
    {
      name: "Loan ID",
      selector: (row) => row.loanID,
      grow: 0.5,
    },
    {
      name: "Seller Name",
      selector: (row) => row.sellerName,
    },
    {
      name: "Next Payment Due",
      selector: (row) => row.nextPaymentDue,
    },
    {
      name: "Overdue Amount",
      selector: (row) => row.overdueAmount,
      sortable: true,
    },
    {
      name: "Total Paid",
      selector: (row) => row.totalPaid,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <span
          style={{
            color: row.status === "Active" ? "#41B8E4" : "red",
          }}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Action",
      cell: () => (
        <ActionButton options={actions} />
      ),
      center: 'true'
    },
  ]

  const options = [
    { label: 'Monthly', action: () => console.log('Monthly') },
    { label: 'biweekly', action: () => console.log('Monthly') },
    { label: 'weekly', action: () => console.log('Monthly') },
  ]

  return (
    <div className="bg-white mt-3 shadow rounded">
      <div className="p-3 d-flex align-items-center justify-content-between">
        <div className="fw-semibold fs-5">Loan Repayment</div>
        <DynamicButton theme="blue" onClick={() => setIsModalOpen(true)}>
          Repayment Cycle
        </DynamicButton>
      </div>
      <DynamicDatatable columns={tableCols} data={tableData} type="yellow" pagination />
      {isModalOpen && (
        <CustomModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen((prev) => !prev)}
          body={
            <div className="bg-white p-4 px-3 rounded text-center">
              <ColoredText color='#e2702f' cn="fs-5 fw-medium my-3">Repayment Cycle</ColoredText>
              <DynamicDropdown options={options} />
              <div className="d-flex justify-content-center align-items-center mt-3">
                <DynamicButton theme="blue">Save</DynamicButton>
              </div>
            </div>
          }
        />
      )}
    </div>
  )
}

export default Repayment
